/* eslint-disable import/no-duplicates */
import { parse as parseFns } from 'date-fns';
import { fr } from 'date-fns/locale/fr';

export default function parse(
  dateString: string,
  pattern: string,
  date?: Date,
): Date {
  // dateString should be defined, but if it's not we default to empty string
  // then date-fns returns 'Invalid Date'.
  // This was the default behavior in date-fns 2.x
  return parseFns(dateString || '', pattern, date || new Date(), {
    locale: fr,
  });
}
